import ErrorFeedback from 'Components/ErrorFeedback/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import evalCondition from 'Helpers/evalCondition'
import { notifyParent } from 'Helpers/notifyParent'
import {
  Button,
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY,
  EmptyState,
  Flex,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  Loading,
  MESSAGE_BOX_VARIANT_HELP,
  MessageBox,
  NoResults,
  TOAST_VARIANT_SUCCESS,
  ToastContainer,
  toastShow,
  Tooltip
} from 'mailup-web-components'
import emptyStateImage from 'mailup-web-components/resources/mailup-web-app/img/svg/empty-state-workflow_2.svg'
import Header from 'Pages/WorkflowsList/components/Header/Header'
import {
  copyWorkflowCallback,
  deleteWorkflowCallback,
  resetPageCallback,
  resetSearchCallback,
  searchWorkflowsCallback
} from 'Pages/WorkflowsList/recoil/callbacks/callbacks'
import { pageState } from 'Pages/WorkflowsList/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useLocation } from 'react-router-dom'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState
} from 'recoil'

import ModalActivateSimulate from 'Components/ModalActivateSimulate'

import {
  modalActivateSimulateActivateCallback,
  modalActivateSimulateCloseCallback
} from 'Pages/WorkflowsList/recoil/callbacks/modalActivateSimulate'
import { modalActivateSimulateState } from 'Pages/WorkflowsList/recoil/state/modalActivateSimulate'
import { ModalActionCopyConfirm } from './components/Modals/ModalActionCopyConfirm'
import { ModalActionCopyWarning } from './components/Modals/ModalActionCopyWarning'
import { ModalDelete } from './components/Modals/ModalDelete'
import { ModalSimulate } from './components/Modals/ModalSimulate'
import { ModalStatus } from './components/Modals/ModalStatus'
import Results from './components/Results'
import Search from './components/Search'
import {
  modalCopy,
  modalCopyWarning,
  modalDelete,
  modalSimulate,
  modalStatus
} from './recoil/state/modals'
import { searchResult } from './recoil/state/search'

const WorkflowsList = () => {
  const intl = useIntl()
  const history = useHistory()

  const query = new URLSearchParams(useLocation().search)
  const saved = query.get('saved')
  const edit = query.get('edit')

  const { loading, loaded, error, severity, canCreateTrigger, isEmptyState } =
    useRecoilValue(pageState)

  const modalActivateSimulate = useRecoilValue(modalActivateSimulateState)

  const goToMShop = evalCondition(
    'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP'
  )
  const fetchResults = useRecoilCallback(searchWorkflowsCallback, [])
  const { items } = useRecoilValue(searchResult)
  const resetSearch = useRecoilCallback(resetSearchCallback, [])
  const resetPage = useRecoilCallback(resetPageCallback, [])

  // modal copy
  const copyWorkflow = useRecoilCallback(copyWorkflowCallback, [])
  const resetCopyModal = useResetRecoilState(modalCopy)
  const {
    show: showModalCopy,
    idWorkflow: modalCopyIdWorkflow,
    fetchData
  } = useRecoilValue(modalCopy)
  const handleModalCopyCancel = () => {
    !fetchData && resetCopyModal()
  }
  const handleModalCopyConfirm = () => {
    !fetchData && modalCopyIdWorkflow && copyWorkflow(modalCopyIdWorkflow)
  }

  //  modal activate simulate
  const modalActivateSimulateClose = useRecoilCallback(
    modalActivateSimulateCloseCallback,
    []
  )

  const handleActivate = useRecoilCallback(
    modalActivateSimulateActivateCallback,
    []
  )

  const handleEdit = () => {
    history.push(
      `/automation/workflow/${modalActivateSimulate.idWorkflow}/edit`
    )
  }

  // modal Simulate
  const { show: showModalSimulate } = useRecoilValue(modalSimulate)
  const resetModalSimulate = useResetRecoilState(modalSimulate)
  const handleModalSimulateCancel = () => {
    resetModalSimulate()
  }

  // modal Status
  const [{ show: showModalStatus }, setModalStatus] =
    useRecoilState(modalStatus)
  const handleModalStatusCancel = () => {
    setModalStatus((prev) => ({
      ...prev,
      show: false
    }))
  }
  const handleModalStatusConfirm = () => {
    notifyParent('redirectMainFrame', [
      'databasebuilding_app_redirector.aspx?r=/databasebuilding/subscriptions/welcome/list'
    ])
  }

  // modal Copy Warning
  const [{ show: showModalCopyWarning, idWorkflow }, setModalCopyWarning] =
    useRecoilState(modalCopyWarning)
  const handleModalCopyWarningCancel = () => {
    setModalCopyWarning((prev) => ({
      ...prev,
      show: false
    }))
  }
  const handleModalCopyWarningConfirm = () => {
    history.push(`/automation/workflow/${idWorkflow}/edit`)
  }

  // modal Delete
  const deleteWorkflow = useRecoilCallback(deleteWorkflowCallback, [])
  const [
    {
      show: showModalDelete,
      name: nameModalDelete,
      idWorkflow: modalDeleteIdWorkflow
    },
    setModalDelete
  ] = useRecoilState(modalDelete)
  const handleModalDeleteCancel = () => {
    setModalDelete((prev) => ({
      ...prev,
      show: false
    }))
  }
  const handleModalDeleteConfirm = () => {
    deleteWorkflow(modalDeleteIdWorkflow)
  }

  const handleUpgradeClick = () => {
    notifyParent('redirectMainFrame', [
      '/console/mshop_redirector.aspx?t=mshopem'
    ])
  }

  useEffect(() => {
    resetSearch()

    return () => {
      resetPage()
    }
  }, [])

  useEffect(() => {
    if (!loaded) {
      fetchResults(true)
      saved &&
        toastShow(
          intl.formatMessage({
            id:
              edit === '1'
                ? 'Load.Alerts.SuccessUpdate'
                : 'Load.AutomationWorkflow.SuccessSaved'
          }),
          TOAST_VARIANT_SUCCESS
        )
    }
  }, [loaded])

  const ButtonNewWorkflow = () => {
    const handleSaveClick = () => {
      history.push('/automation/workflow/0/edit')
    }

    return (
      <Flex justifyContent='flex-end' margin='24px 0 0 0'>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          size={BUTTON_SIZE_LG}
          data-mu-test='cta-NewTask'
          onClick={handleSaveClick}
        >
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.NewAutomationWorkflow'
          })}
        </Button>
      </Flex>
    )
  }

  return (
    <>
      <Tooltip />
      <Header />
      <Loading open={loading} />
      <ToastContainer />
      <ModalActionCopyConfirm
        show={showModalCopy}
        handleCancel={handleModalCopyCancel}
        handleConfirm={handleModalCopyConfirm}
      />
      <ModalActionCopyWarning
        show={showModalCopyWarning}
        handleCancel={handleModalCopyWarningCancel}
        handleConfirm={handleModalCopyWarningConfirm}
      />
      <ModalSimulate
        show={showModalSimulate}
        handleCancel={handleModalSimulateCancel}
      />
      <ModalStatus
        show={showModalStatus}
        handleCancel={handleModalStatusCancel}
        handleConfirm={handleModalStatusConfirm}
      />
      <ModalDelete
        show={showModalDelete}
        name={nameModalDelete}
        handleCancel={handleModalDeleteCancel}
        handleConfirm={handleModalDeleteConfirm}
      />

      <ModalActivateSimulate
        show={modalActivateSimulate.show}
        mode={modalActivateSimulate.mode}
        recipientLimit={modalActivateSimulate.recipientLimit}
        onClose={modalActivateSimulateClose}
        onEdit={handleEdit}
        onActivate={handleActivate}
        idWorkflow={modalActivateSimulate.idWorkflow}
      />

      <PageContainer data-mu-test='c-workflows-list'>
        <ErrorFeedback error={error} severity={severity} />
        {!error && loaded && (
          <>
            {isEmptyState ? (
              <EmptyState
                thumbSrc={emptyStateImage}
                title={intl.formatMessage({
                  id: 'Load.AutomationWorkflow.EmptyStateTitle'
                })}
                description={intl.formatMessage({
                  id: 'Load.AutomationWorkflow.EmptyStateMessage'
                })}
                buttonText={intl.formatMessage({
                  id: 'Load.AutomationWorkflow.EmptyStateBtn'
                })}
                onClickButton={() =>
                  history.push('/automation/workflow/0/edit')
                }
              />
            ) : (
              <>
                <Search />
                <div className='l-section'>
                  {items.length === 0 && (
                    <NoResults
                      text={intl.formatMessage({
                        id: 'Load.SearchRecipients.noResultsTitle'
                      })}
                    />
                  )}
                  {items.length > 0 && <Results items={items} />}
                </div>
              </>
            )}
            {canCreateTrigger && !isEmptyState ? <ButtonNewWorkflow /> : false}
            {!canCreateTrigger && (
              <MessageBox
                variant={MESSAGE_BOX_VARIANT_HELP}
                title={intl.formatMessage({
                  id: 'Load.TriggersList.TitleAlertCreateTriggerLimit'
                })}
              >
                {goToMShop ? (
                  <Flex columnGap='4px'>
                    {intl.formatMessage({
                      id: 'Load.TriggersList.AlertCreateTriggerLimitFirst'
                    })}

                    <Link
                      variant={LINK_VARIANT_HIGHLIGHT}
                      onClick={handleUpgradeClick}
                    >
                      {intl.formatMessage({
                        id: 'Load.TriggersList.UpgradePlanNew'
                      })}
                    </Link>

                    {intl.formatMessage({
                      id: 'Load.TriggersList.AlertCreateTriggerLimitSecond'
                    })}
                  </Flex>
                ) : (
                  <>
                    {intl.formatMessage({
                      id: 'Load.TriggersList.AlertCreateTriggerLimitWL'
                    })}
                  </>
                )}
              </MessageBox>
            )}
          </>
        )}
      </PageContainer>
    </>
  )
}

export default WorkflowsList
